import React, { ReactElement } from "react";
import { InfoBlockPropertyProps } from "./InfoBlockProperty.types";
import { Conditional } from "src/components/Conditional";
import Visage2Icon from "src/visage2/Visage2Icon/Visage2Icon";
import { CaptionBolder, SmallBody } from "src/components/Text";

function InfoBlockProperty({
    children,
    iconName,
    name,
}: InfoBlockPropertyProps): ReactElement {
    return (
        <div className="infoBlockProperty">
            <div className="infoBlockProperty-label">
                <Conditional condition={!!iconName}>
                    <Visage2Icon
                        icon={iconName}
                        color="spintrGrey"
                        size="medium" />
                </Conditional>

                <CaptionBolder color="contentDark">
                    {name}
                </CaptionBolder>
            </div>
            <div className="infoBlockProperty-value">
                <SmallBody color="contentNormal">
                    {children}
                </SmallBody>
            </div>
        </div>
    );
}

export default InfoBlockProperty;